import React, { useState, useEffect } from "react";
import SearchIcon from "../../../../svgs/search.svg";
import AddCircleIcon from "../../../../svgs/add-circle.svg";
import "./SupplierFilter.scss";
import useDebounce from "../../../../../Shared/GeographyFilters/hooks/useDebounce";

const SupplierFilter = ({
  supplierSearch,
  setSupplierSearch,
  setShowSupplierCreateModal,
}) => {
  const [localSupplierSearch, setLocalSupplierSearch] =
    useState(supplierSearch);
  const debouncedSupplierSearch = useDebounce(localSupplierSearch, 400);

  useEffect(() => {
    setSupplierSearch(debouncedSupplierSearch);
  }, [debouncedSupplierSearch, setSupplierSearch]);

  return (
    <div className="filters-section">
      <div className="search-input">
        <img src={SearchIcon} alt="Search Icon" className="search-icon" />
        <input
          type="text"
          id="supplier-search"
          value={localSupplierSearch}
          onChange={(e) => setLocalSupplierSearch(e.target.value)}
          placeholder="Search"
          className="search-input-field"
        />
      </div>
      <button
        className="create-btn"
        onClick={() => setShowSupplierCreateModal(true)}
      >
        <img src={AddCircleIcon} alt="Add Icon" className="btn-icon" />
        Add New Supplier
      </button>
    </div>
  );
};

export default SupplierFilter;
